module.exports = __webpack_public_path__ + "f2ea7f07520ae22bdbf031b4822ac034.pdf";